import script from "./UserProfilePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserProfilePage.vue?vue&type=script&setup=true&lang=ts"

import "./UserProfilePage.vue?vue&type=style&index=0&id=b385e19e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b385e19e"]])

export default __exports__